
import { useMutation, useQuery } from "@tanstack/react-query";
import { tagService } from "services/tagService";
import { FormTagStore, IdForm, FormTagUpdate } from "types";

export function useTag() {
    const getDetail = async (projectId, id) => {
        const data = await tagService.show(projectId, id);
        return data;
    };

    const fetchDataDetail = (projectId, id) => {
        return useQuery({
            queryKey: ['tagDetail', projectId, id],
            enabled: !!projectId,
            queryFn: () => getDetail(projectId, id),
            staleTime: 1000 * 60 * 3,
        });
    }

    const getList = async (projectId, page = 1) => {
        const data = await tagService.onGetList(projectId, page);
        return data;
    };

    const fetchData = (projectId, currentPage, isFetch = 1) => {
        return useQuery({
            queryKey: ['tags', projectId, currentPage, isFetch],
            queryFn: () => getList(projectId, currentPage),
            enabled: !!projectId,
            staleTime: 1000 * 60 * 3,
            select: (data) => ({
                data: data?.data,
                totalPage: data?.totalPage ?? 1,
            }),
        });
    }

    const createTag = useMutation({
        mutationFn: (payload: FormTagStore) => tagService.store(payload),
        onSuccess: async (res) => res,
        onError: (err) => {
            console.error("createTag failed", err);
        },
    });

    const updateTag = useMutation({
        mutationFn: (formData: FormTagUpdate) => tagService.update(formData),
        onSuccess: async (res) => res,
        onError: (err) => {
            console.error("updateTag failed", err);
        },
    });

    const delTag = useMutation({
        mutationFn: (formData: IdForm) => tagService.destroy(formData),
        onSuccess: async (res) => res,
        onError: (err) => {
            console.error("delTag failed", err);
        },
    });

    return { fetchData, fetchDataDetail, getList, createTag, updateTag, delTag }
}
